import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import moment from 'moment';
import SectionLoadingcontainer from './sectionloadingcontainer';
import { updateComponentState } from '../actions/actions';

class RepeatedBreakDowncalls extends Component {
	constructor(props) {
		super(props);
		this.state = {
			fromdate : this.getDate('fromdate'),
			todate : this.getDate('todate'),
			repeatedbreakdowncalls : [],
			totalrepeatedbreakdowncalls : 0,
			loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.tileOnClick = this.tileOnClick.bind(this);
		this.getDate = this.getDate.bind(this);
		this.getTileFooter = this.getTileFooter.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	getDate(param){
		let tempObj = {
			fromdate : null,
			todate : null
		};
		if(this.props.app.companyid == 1 && ['Mumbai New'].includes(this.props.app.branch)){
			let quarterObj = {
				'15/Jan/2024 to 14/Jan/2025' : {
					'Q1': '15/Jan/2024 to 14/Apr/2024','Q2': '15/Apr/2024 to 14/Jul/2024','Q3': '15/Jul/2024 to 14/Oct/2024','Q4': '15/Oct/2024 to 14/Jan/2025'
				},
				'15/Jan/2025 to 14/Jan/2026' : {
					'Q1': '15/Jan/2025 to 14/Apr/2025','Q2': '15/Apr/2025 to 14/Jul/2025','Q3': '15/Jul/2025 to 14/Oct/2025','Q4': '15/Oct/2025 to 14/Jan/2026'
				}
			};
			Object.keys(quarterObj).map((item)=>{
				let yearStart = item.split(' to ')[0];
				let yearEnd = item.split(' to ')[1];

				if(new Date() >= new Date(yearStart) && new Date() <= new Date(yearEnd)){
					let quarter = Object.keys(quarterObj[item]).find((key)=>{
						let startDate = quarterObj[item][key].split(' to ')[0];
						let endDate = quarterObj[item][key].split(' to ')[1];
						if(new Date() >= new Date(startDate) && new Date() <= new Date(endDate)) return key;
					});
					tempObj.fromdate = moment(quarterObj[item][quarter].split(' to ')[0],'DD/MMM/YYYY').toString();
					tempObj.todate = moment(quarterObj[item][quarter].split(' to ')[1],'DD/MMM/YYYY').toString();
				}
			});
		}
		else {
			tempObj.fromdate = moment().startOf('quarter').toString();
			tempObj.todate = moment().endOf('quarter').toString();
		}

		return tempObj[param];
	}

	getTileFooter(){
		let footer = '';
		if(this.props.app.companyid == 1 && ['Mumbai'].includes(this.props.app.branch)) footer = `${moment().format('YYYY')} Q${moment().format('Q')}`;
		else if (this.props.app.branch == 'Mumbai New'){
			let quarterObj = {
				'15/Jan/2024 to 14/Jan/2025' : {
					'Q1': '15/Jan/2024 to 14/Apr/2024','Q2': '15/Apr/2024 to 14/Jul/2024','Q3': '15/Jul/2024 to 14/Oct/2024','Q4': '15/Oct/2024 to 14/Jan/2025'
				},
				'15/Jan/2025 to 14/Jan/2026' : {
					'Q1': '15/Jan/2025 to 14/Apr/2025','Q2': '15/Apr/2025 to 14/Jul/2025','Q3': '15/Jul/2025 to 14/Oct/2025','Q4': '15/Oct/2025 to 14/Jan/2026'
				}
			};
			Object.keys(quarterObj).map((year)=>{
				let yearStart = year.split(' to ')[0];
				let yearEnd = year.split(' to ')[1];
				if(new Date('2025-01-10') >= new Date(yearStart) && new Date('2025-01-10') <= new Date(yearEnd)){
					Object.keys(quarterObj[year]).forEach((quarter)=>{
						let startDate = quarterObj[year][quarter].split(' to ')[0];
						let endDate = quarterObj[year][quarter].split(' to ')[1];

						if(new Date() >= new Date(startDate) && new Date() <= new Date(endDate)){
							footer = `${moment(new Date(startDate)).format('MMM DD')} - ${moment(new Date(endDate)).format('MMM DD')} - ${quarter}`;
						}
					});
				}
			});
		}
		else{
			footer = `${moment().format('MMM YYYY')}`;
		}

		return (
			<div className="row" style={{float: "right",bottom: "0px",color: "#FC786F",position:"absolute",right: "0px"}}>	
				<div className="col-md-12 table-content-small">
					{footer}
				</div>
			</div>
		)
	}

	onload(){
  		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
			axios.get(`/api/repeatedbreakdowncalls?pagetype=widget&fromdate=${new Date(this.state.fromdate).toDateString()}&todate=${new Date(this.state.todate).toDateString()}`).then((response) => {
				if (response.data.message == 'success') {
					
					let repeatedbreakdowncalls=[],totalrepeatedbreakdowncalls=0;
					if(response.data.main && response.data.main.length > 0){
						let ccs_count = {};
						response.data.main.forEach((item)=>{
							totalrepeatedbreakdowncalls += item.count;
							ccs_count[item.zzzcontractcoveragestatus] = item.count;
						});

						if(this.props.app.companyid == 8) totalrepeatedbreakdowncalls = ccs_count['Service Provider'] || 0;
						else totalrepeatedbreakdowncalls = totalrepeatedbreakdowncalls;

						repeatedbreakdowncalls = response.data.main;
					}
				
					this.setState({
						repeatedbreakdowncalls,
						totalrepeatedbreakdowncalls,
						loaderflag : false
					});
					this.props.updateComponentState(this.props.form,{
						repeatedbreakdowncalls,
						totalrepeatedbreakdowncalls,
						loaderflag : false,
						fromdate : this.state.fromdate,
						todate : this.state.todate
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	tileOnClick(){
		if((this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7){
			this.props.history.push("/repeatedbreakdowncallbygroup");
		}else if(this.props.app.companyid == 6 || (this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch))){
			this.props.history.push("/repeatedbreakdowncallbystate");
		}else if (this.props.app.companyid == 8) {
			this.props.history.push({pathname: `/repeatedbreakdowncallbyhospital/null`, params: {groupid: null,territoryid:null}});
		}else{
			this.props.history.push("/repeatedbreakdowncallbydistrict")
		}
	}

	render() {
		let { repeatedbreakdowncalls,totalrepeatedbreakdowncalls } = this.state;
		return (
			<div className="row no-gutters h-100" onClick={()=>{this.tileOnClick()}}>
				<div className="col-md-12">
					<SectionLoadingcontainer isloading={this.state.loaderflag}></SectionLoadingcontainer>
					<div className="row">
						<div className="col-md-12">
							<div className="section-header-title-small" style={{float:'left',color: "#008060"}}>Repeated Breakdown Calls</div>
							<div className="section-count-small" style={{float:'right',color: "#405FFF"}}> {totalrepeatedbreakdowncalls}</div>
						</div>
					</div>
					<div className="row">	
						<div className="col-md-12">
							{repeatedbreakdowncalls.length > 0 ? <table className="table dashboardwidget">
								<tbody>
									{repeatedbreakdowncalls.map((item, key) => {
										return <tr key={key}>
											<td className="text-left table-content-small">{item.zzzcontractcoveragestatus}</td>
											<td className="text-center table-body-count">{item.count}</td>
										</tr>
									})}
								</tbody>
							</table> : null}
						</div>
					</div>
					{
						(!this.props.app.isDemoDashboard) ?
							(this.getTileFooter())
						: null
					}
				</div>
			</div>
		);
	}
}

RepeatedBreakDowncalls = connect(
	(state, props) => {
		let formName = 'repeatedbreakdowncalls';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateComponentState }
)(reduxForm()(RepeatedBreakDowncalls));

export default RepeatedBreakDowncalls;


// WEBPACK FOOTER //
// ./public/react/components/repeatedbreakdowncalls.js